import { useEffect } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import s from "./PartnerBuyer.module.scss";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getPartnerBuyers } from "../../redux/ApplicationSlice";
import { Link } from "react-router-dom";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";

const PartnerBuyer = () => {
  const { t } = useTranslation();
  const buyers = useSelector((state) => state.application.partnerBuyers);
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();

  useEffect(() => {
    dispatch(getPartnerBuyers());
  }, [dispatch]);

  return (
    <div>
      {width > 1130 ? <Header /> : <MobileHeader />}
      <div className={s.content}>
        <h2 className={s.h2}>{t("Партнеры-покупатели")}</h2>
        <div className={s.partners}>
          {Array.isArray(buyers) && buyers.length > 0 ? (
            buyers.map((it) => (
              <div className={s.partner_item}>
                <div className={s.img}>
                  <img src={it?.partner_logo} className={s.partner_logo} />
                </div>
                <div className={s.text}>
                  <div className={s.title}>{it?.title}</div>
                  <div className={s.description}>{it?.description}</div>
                </div>
                <div className={s.site}>
                  Cайт:
                  <Link to={`${it?.url}`} className={s.link}>
                    {it?.url}
                  </Link>
                </div>
              </div>
            ))
          ) : (
            <div className={s.empty}>Пока нет партнеров ...</div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PartnerBuyer;
